<template>
  <div>
    <Header/>
    <Scroll/>
    <div>
      <div class="mall_pageTopWrap">
        <p class="mall_pageTopTit">Brand</p>
      </div>
      <div class="mall_arrB_Box">
            <div class="mall_arrB_contBox"
              v-for="item in statusData.brandData"
              :key="item.brand_ID"
            >
              <router-link :to="{name: 'BrandDetail', query: {brand_ID: item.brand_ID}}">
                <div class="mall_arrB_imgBox">
                  <p class="mall_arrB_logoImg"><!-- 브랜드 로고 -->
                    <img
                      :src="item.brand_logo_image"
                      :alt="item.brand_kor_name"
                    />
                  </p>
                  <p class="mall_arrB_hoverImg"><!-- 하버 배경이미지 -->
                    <img
                      :src="item.brand_logo_hover"
                      :alt="item.brand_eng_name"
                    />
                  </p>
                </div>
              </router-link>
            </div>
          </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_brand_use
} from '../../ETC/Axios.vue'

export default {
  name: 'Brand',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        brandData: []
      })
    }
  },
  mounted () {
    get_brand_use().then(result_data => {
      this.statusData.brandData = result_data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Brand/Brand.vue